import { cn } from "@/lib/utils";
import { ComponentProps, HTMLProps } from "react";
import { CustomDialogFooter } from "./custom-dialog";
import { SheetContent, SheetHeader } from "./sheet";

export const CustomSheetContent = ({
  className,
  ...props
}: ComponentProps<typeof SheetContent>) => {
  return <SheetContent className={cn("w-[500px] p-0", className)} {...props} />;
};

export const CustomSheetHeader = ({
  className,
  ...props
}: ComponentProps<typeof SheetHeader>) => {
  return (
    <SheetHeader className={cn("p-8 py-4 border-b", className)} {...props} />
  );
};

export const CustomSheetBody = ({
  className,
  ...props
}: HTMLProps<HTMLDivElement>) => {
  return <div className={cn("h-full p-8 gap-8", className)} {...props} />;
};

export const CustomSheetFooter = CustomDialogFooter;
